<template>
	<div>
		<div class="row">
			<div class="col-md-9">
				<h1>{{$t('tag-manager')}}</h1>
			</div>
			<div class="col-md-3">
				<router-link class="btn btn-primary btn-block btn-lg mb-3" to="/settings/tag">
					{{ $t('new-tag') }}
				</router-link>
			</div>
		</div>
        <Table
            :loading="loading"
            :submitting="submitting"
            :cols="[
                { key: 'name', heading: $t('name'), size: 6 },
                { key: 'taggroup_id', heading: $t('tag-group-name'), size: 6,
                    cb: tag => {
                        const match = taggroups.find(obj => obj.id == tag.taggroup_id);
                        if(match){
                            const name = match.name;
                            return name
                        } else {
                            return ;
                        }

                    }
                }
            ]"
            :data="tags"
            breakpoint="md"
            :filters="{
                ...filters,
                page: filters.page,
                page_size: filters.page_size,
            }"
            :searchable="true"
            :scrollPaginate="true"
            @refresh="refresh"
            @selectItem="tag => $router.push(`/settings/tag/${tag.id}`)"
        ></Table>
	</div>
</template>

<script>

import Table from "src/components/Table/Table.vue";


export default {
	components: {
        Table
	},
	data() {
		return {
            tags:[],
            taggroups:[],
            loading: true,
			submitting: false,
			filters: {
				page: 1,
				page_size: 30,
				total: 0,
				search: '',
			}
		};
	},
	mounted() {
        this.fetchTags();
        this.fetchTagGroups();
	},
	methods: {
		newSearch() {
			this.getTags();
		},
        fetchTags() {
			if (this.submitting) return
			this.submitting = true

			return this.$cfetch(`${this.$settings.APIBaseURL}/tags/list`, {
				method: 'GET',
				data: this.filters,
			})
			.then(res => {
				if (res.status !== 'SUCCESS') throw new Error('Unexpected error listing tags')
				this.tags = res.results
                this.loading = false
				this.filters = { ...this.filters, ...res.pagination }
			})
			.catch(err => {
				this.$log.error.call(this, err)
				this.$store.commit('openDialog', {
					title: this.$t('something-went-wrong'),
					content: this.$t('error-listing-tags')
				})
			})
			.finally(() => {
				this.submitting = false
			})
		},
        fetchTagGroups(){
            return this.$cfetch(`${this.$settings.APIBaseURL}/tags/groups/list`, {
				method: 'POST',
				data: {},
			})
			.then(res => {
				if (res.status !== 'SUCCESS') throw new Error('Unexpected error listing tags')
				this.taggroups = res.results.map(item => {
                    // eslint-disable-next-line no-unused-vars
                    const { reflectiononly, tags, ...newObject } = item;
                    return newObject;
                })
			})
			.catch(err => {
				this.$log.error.call(this, err)
				this.$store.commit('openDialog', {
					title: this.$t('something-went-wrong'),
					content: this.$t('error-listing-tag-groups')
				})
			})
        },
        refresh(filters) {
			this.filters = { ...this.filters, ...filters }
			this.fetchTags();
		},

	},
	computed: {}
};
</script>
